import React, { useState } from "react";
import CountrySelectFormGroup from "./CountrySelectFormGroup";
import GuideWork from "./GuideWork";
import GuideSocialLinksFormGroup from "./GuideSocialLinksFormGroup";
import GuideRolesFormGroup from "./GuideRolesFormGroup";
import GuideTypeFormGroup from "./GuideTypeFormGroup";
import GuideAgeFormGroup from "./GuideAgeFormGroup";
import SelectCountryCode from "./SelectCountryCode";
import { usePopup } from "./PopupContext";
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4242/api/v1";


const GuideForm = (props) => {
    const [approveApp, setApproveApp] = useState(props.status === 'approved')
    const [selectedTypes, setSelectedTypes] = useState(props.selectedGuide.types)
    const [realRoles, setRealRoles] = useState(props.selectedGuide.realRoles || [])
    const [name, setName] = useState(props.selectedGuide.name)
    const [email, setEmail] = useState(props.selectedGuide.email)
    const [availability, setAvailability] = useState(props.selectedGuide.availability)
    const [displayEmail, setDisplayEmail] = useState(props.selectedGuide.displayEmailToCustomers)
    const [phone_number, setPhoneNumber] = useState(props.selectedGuide.phone_number)
    const [encrypted_phone_number, setPhoneEncryption] = useState(props.selectedGuide.weakly_encrypted_phone_number)
    const [willUseWhatsapp, setWillUseWhatsapp] = useState(props.selectedGuide.willUseWhatsapp)
    const [meetingAddress, setMeetingAddress] = useState(props.selectedGuide.meetingAddress)
    const [doesAppointments, setDoesAppointments] = useState(props.selectedGuide.doesAppointments)
    const [gender, setGender] = useState(props.selectedGuide.gender)
    const [age, setAge] = useState(props.selectedGuide.age)
    const [country, setCountry] = useState(props.selectedGuide.country)
    const [status, setStatus] = useState(props.selectedGuide.status)
    const [work, setWork] = useState(props.selectedGuide.work || "")
    const [social_links, setSocialLinks] = useState(props.selectedGuide.social_links)
    const [motivation, setMotivation] = useState(props.selectedGuide.motivation)
    const [profilePictureFile, setProfilePictureFile] = useState(null);
    const [profilePictureURL, setProfilePictureURL] = useState(props.selectedGuide.profilePictureURL)
    const pop = usePopup()

    const handleBackButton = (e) => {
        e.preventDefault()
        props.setShowGuideDetails(false)
    }
    
    const handleReject = (e) => {
        e.preventDefault()
        handleFormSubmit({}, true)
    }

    const handleFormSubmit = async (e, rejected = false) => {
        if (e.preventDefault) e.preventDefault()
        let updatedGuide = {...props.selectedGuide}

        if (rejected) { 
            updatedGuide.isRejected = true
         }

        // form submit logic
        if (profilePictureFile) {
            try {
                // 1. Request presigned upload URL from backend
                const response = await fetch(
                    `${API_URL}/admin/generate-guide-picture-url`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${window.localStorage.getItem('adminToken')}`
                        },
                        body: JSON.stringify({
                            fileName: profilePictureFile.name,
                            fileType: profilePictureFile.type,
                            guideId: updatedGuide._id.toString(),
                            isApplicant: true
                        }),
                    }
                );
                
                const data = await response.json();

                if (!data.success) {
                    throw new Error("Failed to generate upload URL");
                }

                const { uploadUrl, viewUrl, imageKey } = data;

                // 2. Upload file directly to S3
                const uploadResponse = await fetch(uploadUrl, {
                    method: "PUT",
                    body: profilePictureFile,
                    headers: {
                        "Content-Type": profilePictureFile.type
                    }
                });

                if (!uploadResponse.ok) {
                    const errorText = await uploadResponse.text();
                    console.error("S3 upload error:", errorText);
                }

                buildAndReturnGuide(updatedGuide, imageKey)

            } catch (error) {
                console.error("Profile picture upload failed:", error);
                pop(error.message, 'flash', false);
            }
        } else {
            buildAndReturnGuide(updatedGuide)
        }

        buildAndReturnGuide(updatedGuide)
    }

    const buildAndReturnGuide = (updatedGuide, profilePictureKey = false) => {
        updatedGuide.types = selectedTypes
        updatedGuide.realRoles = realRoles
        updatedGuide.name = name
        updatedGuide.email = email
        updatedGuide.displayEmailToCustomers = displayEmail
        updatedGuide.phone_number = phone_number
        updatedGuide.willUseWhatsapp = willUseWhatsapp
        updatedGuide.meetingAddress = meetingAddress
        updatedGuide.doesAppointments = doesAppointments
        updatedGuide.gender = gender
        updatedGuide.age = age
        updatedGuide.country = country
        updatedGuide.status = status
        updatedGuide.work = work
        updatedGuide.social_links = social_links
        updatedGuide.motivation = motivation
        updatedGuide.profilePictureURL = profilePictureURL
        updatedGuide.weakly_encrypted_phone_number = encrypted_phone_number
        updatedGuide.availability = availability

        if(props.isApplicant) {
            updatedGuide.isApplicant = true
            updatedGuide.approveApp = approveApp
        }

        if (profilePictureKey) {
            updatedGuide.profilePictureKey = profilePictureKey
            updatedGuide.prevProfilePictureKey = props.selectedGuide.profilePictureKey || true
        }
        return props.updateGuide(updatedGuide)
    }

    const handleFileUpdate = (file) => {
        if (!file) return;
        setProfilePictureFile(file)
        const previewUrl = URL.createObjectURL(file);
        setProfilePictureURL(previewUrl);
    };

    return (
            <form className="form">
                <h3>{props.isApplicant ? 'Applicant' : 'Guide'} Details</h3>
                <div className="form-group inline">
                    <label>
                        Application Date: {new Date(props.selectedGuide.applied_at).toLocaleDateString()}
                    </label>
                    <label>
                        EPN: {encrypted_phone_number}
                    </label>
                </div>
                <div className="form-group">
                    <label>Applicant Image</label>
                    {profilePictureURL && <img src={profilePictureURL} alt="Profile" style={{ width: 150, height: "auto" }} />}
                    <input type="file" accept="image/*" onChange={(e) => handleFileUpdate(e.target.files[0])} />
                </div>
                <div className="form-group form-group-row">
                    <div className="form-group">
                        <label>Status</label>
                        {(<span className={`badge sm ${status}`}>{status}</span>)}
                    </div>
                    <div className="form-group">
                        <label>Will Use WhatsApp</label>
                        <label className="switch">
                            <input type="checkbox" checked={willUseWhatsapp} onChange={() => setWillUseWhatsapp(!willUseWhatsapp)} />
                            <span className="slider"></span>
                        </label>
                    </div>
                </div>
                <div className="form-group">
                    <label>Name</label>
                    <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
                </div>
                <div className="form-group form-group-row split">
                    <div className="form-group">
                        <label>Gender</label>
                        <select name="gender" value={gender} onChange={(e) => setGender(e.target.value)}>
                            <option value="">Select</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                        </select>
                    </div>
                    <GuideAgeFormGroup 
                        age={age} 
                        setAge={setAge} />
                </div>
                <div className="form-group form-group-row split">
                    <div className="form-group">
                        <label>Email</label>
                        <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "baseline", marginTop: '10px'}}>
                            <label htmlFor="phone">WhatsApp Number:</label>
                            <div style={{display: "flex", flexDirection: "row", alignItems: "center", gap: '10px'}}>
                                <input
                                    name="phone"
                                    onChange={(e) => {
                                        setPhoneNumber(e.target.value);
                                    }}
                                    className="guide-signup-phone-input" 
                                    value={phone_number}
                                    type="tel" 
                                    placeholder={"Phone number"} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="form-group">
                    <label>In-Person Meeting Address</label>
                    <input type="text" value={meetingAddress} onChange={(e) => setMeetingAddress(e.target.value)} />
                </div> */}
                <CountrySelectFormGroup
                    selectedGuide={props.selectedGuide}
                    setCountry={setCountry}
                />
                <div className="form-group">
                    <label>Motivation</label>
                    <textarea type="textarea" value={motivation} onChange={(e) => setMotivation(e.target.value)} />
                </div>
                <div className="form-group form-group-row split">
                    <GuideTypeFormGroup 
                        guideTypes={props.guideTypes}
                        selectedTypes={selectedTypes}
                        setTypes={setSelectedTypes} />
                    <GuideRolesFormGroup
                        realRoles={realRoles}
                        setRealRoles={setRealRoles} />
                </div>
                <GuideSocialLinksFormGroup 
                    social_links={social_links}
                    setSocialLinks={setSocialLinks} />
                <div className="form-group form-group-row split">
                    <GuideWork
                        work={work} 
                        setWork={setWork} />
                </div>

                {props.isApplicant && (
                    <div className="form-group inline">
                        <div className="form-group" style={{alignItems: 'center'}}>
                            <label>Approve Applicant</label>
                            <label className="switch">
                                <input type="checkbox" checked={approveApp} onChange={() => {setApproveApp(!approveApp)}} />
                                <span className="slider"></span>
                            </label>
                        </div>
                    </div>
                )}
                
                <div className="form-actions">
                    <button className="manage-item-action" onClick={handleBackButton}>Back to List</button>
                    {props.isApplicant && <button className="manage-item-action red" onClick={handleReject}>Reject</button>}
                    <button className="manage-item-action boggler" onClick={handleFormSubmit}>Update</button>
                </div>
            </form>
    );
}

export default GuideForm;